import { usePublishedContext } from '@/components/views/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/components/views/published/usePublishedSnapshotQuery';
import { useGetEstimationSchemesQuery } from '@/lib/queries/common/useGetEstimationScheme';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const useEstimationSchemesQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const schemesQuery = useGetEstimationSchemesQuery({ enabled: !isPublished && enabled });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: commonQueryKeys.estimationSchemes.all(),
    getSnapshot: () => publishedContext?.estimationSchemes,
  });

  return isPublished ? publishedQuery : schemesQuery;
};
